import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BSKT_SuKiens, BSKT_SuKiens_ViewModel } from '../../services/su-kien/SuKienModels';

interface SuKienState {
    listData: BSKT_SuKiens_ViewModel[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed';

    selectedSuKienId: number | null;
    selectedLopId: number | null;

    // ====== THÊM 2 FIELD NÀY ======
    selectedDotHocId: number | null;
    selectedNamTuyenSinh: number | null;

    isShowCreateOrEditModal: boolean;
    isShowConfirmDeleteModal: boolean;
    createOrEditModel: BSKT_SuKiens | null;
}

const initialState: SuKienState = {
    listData: [],
    status: 'idle',
    selectedSuKienId: null,
    selectedLopId: null,

    // ====== THÊM GIÁ TRỊ KHỞI TẠO ======
    selectedDotHocId: null,
    selectedNamTuyenSinh: null,

    isShowCreateOrEditModal: false,
    isShowConfirmDeleteModal: false,
    createOrEditModel: {
        created_time: new Date(),
        created_user_id: '',
        ID: 0,
        ID_cb: '',
        ID_lop_bskt: 0,
        ID_phong: 0,
        is_deleted: false,
        last_modified_times: new Date(),
        last_modified_user_id: '',
        Ngay_hoc: new Date(),
        So_tiet: 0,
        Tiet: 0
    }
};

const suKienSlice = createSlice({
    name: 'suKien', // key trong store vẫn là suKienTinChi do bạn map ở rootReducer
    initialState,
    reducers: {
        setList: (state, action: PayloadAction<BSKT_SuKiens_ViewModel[]>) => {
            state.listData = action.payload;
        },
        setStatus: (state, action: PayloadAction<SuKienState['status']>) => {
            state.status = action.payload;
        },
        setSelectedSuKienId: (state, action: PayloadAction<number | null>) => {
            state.selectedSuKienId = action.payload;
        },
        setSelectedLopId: (state, action: PayloadAction<number | null>) => {
            state.selectedLopId = action.payload;
        },

        // ====== THÊM 2 REDUCER ======
        setSelectedDotHocId: (state, action: PayloadAction<number | null>) => {
            state.selectedDotHocId = action.payload;
        },
        setSelectedNamTuyenSinh: (state, action: PayloadAction<number | null>) => {
            state.selectedNamTuyenSinh = action.payload;
        },

        setCreateOrEditModel: (state, action: PayloadAction<BSKT_SuKiens | null>) => {
            state.createOrEditModel = action.payload;
            state.isShowCreateOrEditModal = true;
        },
        setShowCreateOrEditModal: (state, action: PayloadAction<boolean>) => {
            state.isShowCreateOrEditModal = action.payload;
        },
        setShowConfirmDeleteModal: (state, action: PayloadAction<number>) => {
            if (action.payload <= 0) {
                state.isShowConfirmDeleteModal = false;
            } else {
                state.selectedSuKienId = action.payload;
                state.isShowConfirmDeleteModal = true;
            }
        },
        insertSuccess: (state, action: PayloadAction<BSKT_SuKiens_ViewModel>) => {
            state.listData.push(action.payload);
            state.isShowCreateOrEditModal = false;
        },
        updateSuccess: (state, action: PayloadAction<BSKT_SuKiens_ViewModel>) => {
            const payload = action.payload;
            console.log('Update action payload:', payload);

            if (!payload || !payload.ID) {
                console.error('Update payload is missing ID');
                return;
            }

            const index = state.listData.findIndex((item) => item.ID === payload.ID);

            if (index !== -1) {
                // Merge dữ liệu cũ + mới để tránh mất field
                state.listData[index] = {
                    ...state.listData[index],
                    ...payload
                };
            } else {
                console.warn('Item not found in listData with ID:', payload.ID);
            }

            state.isShowCreateOrEditModal = false;
        },
        deleteSuccess: (state, action: PayloadAction<number>) => {
            state.isShowConfirmDeleteModal = false;
            if (action.payload) {
                state.listData = state.listData.filter(
                    (item) => item.ID !== state.selectedSuKienId
                );
                state.selectedSuKienId = null;
            }
        },
        resetState: () => initialState
    }
});

export const {
    setList,
    setStatus,
    setSelectedSuKienId,
    setSelectedLopId,
    setSelectedDotHocId,       // export thêm
    setSelectedNamTuyenSinh,   // export thêm
    setCreateOrEditModel,
    setShowCreateOrEditModal,
    setShowConfirmDeleteModal,
    insertSuccess,
    updateSuccess,
    deleteSuccess,
    resetState
} = suKienSlice.actions;

export const suKienReducer = suKienSlice.reducer;
